// utils.ts — re-exports all utility functions from the shared module.
// See src/scripts/shared-utils.ts for implementations.
// RegionInfo is exported from its authoritative source (aws-regions.ts) — not shared-utils.ts.
export type { RegionInfo } from "./aws-regions.js";
export {
  clearLocalStorage,
  constructSignature,
  detectOS,
  getEnumKeyByEnumValue,
  getRegionInfo,
  getTokenPayload,
  getXiTokenFromResponse,
  pollSession,
  requestToken,
  validateTokenPayload,
  waitForDelay,
} from "./shared-utils.js";
